/* global axios */
import ApiClient from './ApiClient';

class MetaLeadgenConfigsAPI extends ApiClient {
  constructor() {
    super('meta_leadgen_configs', { accountScoped: true });
  }

  create(config) {
    return axios.post(this.url, { meta_leadgen_config: config });
  }

  update(id, config) {
    return axios.patch(`${this.url}/${id}`, { meta_leadgen_config: config });
  }

  sources() {
    return axios.get(`${this.url}/sources`);
  }
}

export default new MetaLeadgenConfigsAPI();
